import axios from "axios";
import { MethodType } from '../common/constants';
import { UI_ENV } from '../config/env';
const apiUrl = UI_ENV === 'prod' ? 'https://cci.netskope.io/api/' : 'http://127.0.0.1:4000/api/';

const uri = `${apiUrl}users/fetch`;
export const uri1 = `${apiUrl}`;
const uriToken = `${apiUrl}users/authToken`;

// The session token now lives in an HttpOnly cookie (ENG-1070983 #7). Send it
// automatically with every request instead of reading it from localStorage.
axios.defaults.withCredentials = true;

// Clear the server-side session cookie.
export const logout = async () => {
    try {
        await axios.post(`${apiUrl}users/logout`);
    } catch (error) {
        console.log(error);
    }
};

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('data');
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const bodyParameters = {
  type: "fetch",
  qry: "qryv",
  firstVal: "2020-09-01",
  secondVal: "2020-09-30",
};

const bodyParamPreProc = {
  type: "fetch",
  qry: "qryv",
  preProcess: true,
  preProcFunc: "rowDataCluttering",
  firstVal: "2020-09-01",
  secondVal: "2020-09-30",
};

const bodyParamPre = {
  type: "fetch",
  qry: "qryv",
  preProcess: true,
  preProcFunc: "rowDataCluttering",
  firstVal: "2020-09-01",
  secondVal: "2020-09-30",
};

export const fetchReportSearch = async (tenant, admin, url, query) => {
  console.log("data", bodyParameters);
  bodyParameters["qry"] = query;
  bodyParameters["firstVal"] = tenant;
  bodyParameters["secondVal"] = admin;
  bodyParameters["thirdVal"] = url;
  try {
    const { data } = await axios.post(uri, bodyParameters);
    // console.log("data in fet stat", data["data"]);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchJwtToken = async (idToken) => {
  try {
    // The server sets the session token as an HttpOnly cookie; nothing to
    // persist client-side (ENG-1070983 #7).
    const { data } = await axios.post(uriToken, { idToken });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchTrend = async (query, limit) => {
  bodyParameters["qry"] = query;
  bodyParameters["firstVal"] = limit;

  // console.log("data", bodyParameters, "json is", limit);

  try {
    const { data } = await axios.post(uri, bodyParameters);
    // console.log("data is ", data["data"][0]);
    return data["data"][0];
  } catch (error) {
    console.log(error);
  }
};

export const fetchJsData = async (jsVal) => {
  try {
    const { data } = await axios.post(uri, jsVal);
    // console.log(data["data"]);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchGeoIp = async (jsVal) => {
  try {
    const { data } = await axios.post(
      "https://cci.netskope.io/api/users/geoip",
      jsVal
    );
    // console.log(data["data"]);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchJsAppData = async (jsVal, jsVal2) => {
  try {
    const { data } = await axios.post(uri, jsVal);
    const data2 = await axios.post(uri, jsVal2);
    const { secondVal } = jsVal;
    const rels = [
      parseInt(secondVal.substr(10, 2)),
      parseInt(secondVal.substr(10, 2)) + 1,
      parseInt(secondVal.substr(10, 2)) + 2,
    ];
    let dataSet = [],
      i = 1;
    // console.log(rels);
    for (var ele of rels) {
      // console.log(`d` + (i - 1) + (i - 1 + 1));
      dataSet.push({
        application_id: i * 17,
        id: i,
        release: `Release ` + ele,
        actName: data["data"][1][0][`act` + i],
        domName: data2["data"]["data"][1][0][`dom` + i],
        aComp: data["data"][1][0][`a` + (i - 1) + (i - 1 + 1)],
        dComp: data2["data"]["data"][1][0][`d` + (i - 1) + (i - 1 + 1)],
      });

      //activity Comparator
      /* eslint-disable no-unused-expressions */
      dataSet[i - 1]["aComp"] && dataSet[i - 1]["aComp"] != 0
        ? ((dataSet[i - 1]["actComp"] = data["data"][1][0][`act` + (i - 1)]),
          ((dataSet[i - 1]["actAdded"] = dataSet[i - 1]["actName"]
            .split(",")
            .filter((x) => !dataSet[i - 1]["actComp"].split(",").includes(x))),
          (dataSet[i - 1]["actRemoved"] = dataSet[i - 1]["actComp"]
            .split(",")
            .filter((x) => !dataSet[i - 1]["actName"].split(",").includes(x)))))
        : (dataSet[i - 1]["actComp"] = "No Change");

      //domain Comparator
      /* eslint-disable no-unused-expressions */
      dataSet[i - 1]["dComp"] && dataSet[i - 1]["dComp"] != 0
        ? ((dataSet[i - 1]["domComp"] =
            data2["data"]["data"][1][0][`dom` + (i - 1)]),
          ((dataSet[i - 1]["domAdded"] = dataSet[i - 1]["domName"]
            .split(",")
            .filter((x) => !dataSet[i - 1]["domComp"].split(",").includes(x))),
          (dataSet[i - 1]["domRemoved"] = dataSet[i - 1]["domComp"]
            .split(",")
            .filter((x) => !dataSet[i - 1]["domName"].split(",").includes(x)))))
        : ((dataSet[i - 1]["domComp"] = "No Change"),
          (dataSet[i - 1]["domChanged"] = "No Change"));

      i++;
    }
    // console.log(dataSet);

    return dataSet;
  } catch (error) {
    console.log(error);
  }
};

export const fetchJsAppAddData = async (jsVal) => {
  try {
    const { data } = await axios.post(uri, jsVal);
    const { secondVal } = jsVal;
    const rels = [
      parseInt(secondVal.substr(10, 2)),
      parseInt(secondVal.substr(10, 2)) + 1,
      parseInt(secondVal.substr(10, 2)) + 2,
    ];
    let dataSet = [],
      i = 1;
    console.log(rels, "***** ", data);
    for (var ele of rels) {
      // console.log(`d` + (i - 1) + (i - 1 + 1));
      dataSet.push({
        application_id: data["data"][1][0]["application_id"] * 17,
        id: i,
        release: `Release ` + ele,
        priority: data["data"][1][0][`p` + i],
        ins_support: data["data"][1][0][`ins` + i],
        syn_support: data["data"][1][0][`syn` + i],
        dlp: data["data"][1][0][`dlp` + i],
        tss: data["data"][1][0][`tss` + i],
      });

      i++;
    }
    // console.log(dataSet);

    return dataSet;
  } catch (error) {
    console.log(error);
  }
};

export const fetchUserVal = async (query, jsVal) => {
  bodyParameters["qry"] = query;
  bodyParameters["firstVal"] = jsVal["firstVal"];
  bodyParameters["secondVal"] = jsVal["secondVal"];
  bodyParameters["thirdVal"] = jsVal["thirdVal"];
  bodyParameters["fourthVal"] = jsVal["fourthVal"];

  // console.log("data", bodyParameters, "json is", jsVal);

  try {
    const { data } = await axios.post(uri, bodyParameters);
    // console.log(data["data"]);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchReport = async (query) => {
  console.log("data", bodyParameters["qry"]);
  bodyParameters["qry"] = query;

  try {
    const { data } = await axios.post(uri, bodyParameters);
    // console.log(data["data"]);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchRecPreProc = async (date1, date2, query, preProc) => {
  bodyParamPre["firstVal"] = date1;
  bodyParamPre["secondVal"] = date2;
  bodyParamPre["qry"] = query;
  bodyParamPre["preProcFunc"] = preProc;
  // console.log('body params ',bodyParamPre);

  try {
    const { data } = await axios.post(uri, bodyParamPre);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchRep = async (date1, date2, query) => {
  bodyParamPreProc["firstVal"] = date1;
  bodyParamPreProc["secondVal"] = date2;
  bodyParamPreProc["qry"] = query;

  try {
    const { data } = await axios.post(uri, bodyParamPreProc);
    return data["data"][0];
  } catch (error) {
    console.log(error);
  }
};

export const fetchValue = async (date1, date2, query) => {
  bodyParameters["firstVal"] = date1;
  bodyParameters["secondVal"] = date2;
  bodyParameters["qry"] = query;

  try {
    const { data } = await axios.post(uri, bodyParameters);
    return data["data"][0]["count"];
  } catch (error) {
    console.log(error);
  }
};

export const fetchDays = async (date1, date2, query) => {
  bodyParameters["firstVal"] = date1;
  bodyParameters["secondVal"] = date2;
  bodyParameters["qry"] = query;

  try {
    const { data } = await axios.post(uri, bodyParameters);
    console.log("this data is -- ", data);
    return data["data"][0]["days"];
  } catch (error) {
    console.log(error);
  }
};

export const fetchTabData = async (date1, date2, query) => {
  bodyParameters["firstVal"] = date1;
  bodyParameters["secondVal"] = date2;
  bodyParameters["qry"] = query;

  try {
    const { data } = await axios.post(uri, bodyParameters);
    return data["data"];
  } catch (error) {
    console.log(error);
  }
};

export const fetchVal = async () => {
  try {
    const { data } = await axios.get(uri1);

    console.log("inside api - ", data);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const researchAuth = async (paras) => {
  try {
    const { data } = await axios.post(uri1 + "custom/researchAuth", paras);
    return data["accessToken"];
  } catch (error) {
    throw error;
  }
};

export const researchUI = async (paras) => {
  try {
    const { data } = await axios.post(uri1 + "custom/researchUi", paras);
    return data;
  } catch (error) {
    throw error;
  }
};

export const marketPlaceUI = async (paras) => {
    try {
        const { data } = await axios.post(uri1 + 'custom/marketplace', paras);
        return data;
    } catch (error) {
        throw error;
    }
};

export const anomalyEngine = async (paras) => {
  try {
    const { data } = await axios.post(uri1 + "custom/anomalyEngine", paras);
    return data;
  } catch (error) {
    throw error;
  }
};

export const tunnelMonitor = async (paras, config = {}) => {
    try {
        const { data } = await axios.post(uri1 + 'custom/tunnelMonitor', paras, config);
        return data;
    } catch (error) {
        throw error;
    }
};

export const cciGpt = async (paras, config = {}) => {
    try {
        const { data } = await axios.post(uri1 + 'custom/cciGpt', paras, config);
        return data;
    } catch (error) {
        throw error;
    }
};

export const cciGptService = async (paras, config = {}) => {
    try {
        const url = 'https://cci.netskope.io/api/';
        const { data } = await axios.post(url + 'custom/cciGptService', paras, config);
        return data;
    } catch (error) {
        throw error;
    }
};

function actDomDiff(a1, a2) {
  var a = [],
    diff = [];
  for (var i = 0; i < a1.length; i++) {
    a[a1[i]] = true;
  }
  for (var i = 0; i < a2.length; i++) {
    if (a[a2[i]]) {
      delete a[a2[i]];
    } else {
      a[a2[i]] = true;
    }
  }
  for (var k in a) {
    diff.push(k);
  }
  return diff;
}

export const callApi = async (config) => {
    const { url, data, method, signal, options } = config;
    if (!url) throw new Error('No url was provided');
    if (!method) throw new Error('No method was provided');

    const mergedOptions = {
        signal,
        ...options,
    };

    const apiUrl = `${uri1}${url}`;

    try {
        let response = null;
        switch (method?.toUpperCase()) {
            case MethodType.POST: {
                response = await axios.post(apiUrl, data, mergedOptions);
                break;
            }
            case MethodType.PUT: {
                response = await axios.put(apiUrl, data, mergedOptions);
                break;
            }
            case MethodType.PATCH: {
                response = await axios.patch(apiUrl, data, mergedOptions);
                break;
            }
            case MethodType.DELETE: {
                response = await axios.delete(apiUrl, { data, ...mergedOptions });
                break;
            }
            case MethodType.GET: {
                response = await axios.get(apiUrl, { ...mergedOptions, params: data });
                break;
            }
            default:
                break;
        }
        return {
            resp: response.data,
            statusCode: response.status,
            err: null,
        };
    } catch (error) {
        return {
            resp: error.response?.data,
            statusCode: error.response?.status,
            err: error,
        };
    }
};
